<template>
    <validation-observer ref="fields">

        <v-row class="pb-2 mx-0 pt-4">
            <v-col class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6 pt-4">
                <validation-provider name="Nome" rules="required" v-slot="{ errors }">
                    <v-text-field
                        type="text"
                        label="Nome"
                        v-model="model['name']"
                        :error-messages="errors"
                        outlined
                        dense
                        ref="name"
                    ></v-text-field>
                </validation-provider>
            </v-col>
        </v-row>
        
    </validation-observer>    
</template>

<script>
import Vue from 'vue'

export default {
	name: 'vehicletype-fields',
	props: {
		create: {
			type: Boolean,
			default: false,
		},
		edit: {
			type: Boolean,
			default: false,
		},
		model: Object,
		info: Object,
	},
        
	data() {
		return {
			dialog: false,
			dialogType: null,
		}
	},

}
</script>

<style>

</style>